import { render, staticRenderFns } from "./cabinetAppearance.vue?vue&type=template&id=2623e7ee&scoped=true&"
import script from "./cabinetAppearance.vue?vue&type=script&lang=js&"
export * from "./cabinetAppearance.vue?vue&type=script&lang=js&"
import style0 from "./cabinetAppearance.vue?vue&type=style&index=0&id=2623e7ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2623e7ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2623e7ee')) {
      api.createRecord('2623e7ee', component.options)
    } else {
      api.reload('2623e7ee', component.options)
    }
    module.hot.accept("./cabinetAppearance.vue?vue&type=template&id=2623e7ee&scoped=true&", function () {
      api.rerender('2623e7ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/appearance/cabinetAppearance.vue"
export default component.exports